import React from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';

const Reviews = ({ productCode, setRef, reviewsNumber, display, ratingStars, avgNumberOfStars }) =>
  createPortal(
    <dl
      key={`bv-reviews_${productCode}`}
      ref={ref => setRef(ref, 'reviews')}
      className={`accordion-container ${display ? '' : 'display-none'}`}
    >
      <dt className="accordion-header">
        <button type="button" className="accordion-trigger js-tracking-accordion" data-tracking-name="product reviews">
          <FormattedMessage id="products.pdp.description.reviews.title" description="Reviews" />
          <div className="product-desc__reviews--wrapper">
            <div className="product-desc__reviews-stars" dangerouslySetInnerHTML={{ __html: ratingStars }} />
            <span className="product-desc__reviews-average">{avgNumberOfStars}</span>
            <span className="product-desc__reviews-number">({reviewsNumber})</span>
          </div>

          <i className="fa-regular fa-chevron-down" />
        </button>
      </dt>
      <dd className="accordion-panel">
        <div className="content" data-bv-show="reviews" data-bv-product-id={productCode} />
      </dd>
    </dl>,
    document.getElementById('product-details-reviews')
  );

export default Reviews;
